<template>
  <div class="mt-1 d-flex full-width">
    <div
      v-if="!hideLabel"
      class="label-name mb-1 flex-grow-0"
      style="color: #000;font-size:16px"
    >
      <label for="">
        {{ label }}
      </label>
    </div>
    <v-menu
      close-on-click
      :close-on-content-click="false"
      :disabled="readonly"
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" :color="color" depressed v-on="on" style="border: 1px solid #4D5656"> </v-btn>
      </template>
      <v-color-picker
        v-if="!readonly"
        v-model="color"
        class="flex-grow-0"
        hide-mode-switch
        :mode="mode"
        show-swatches
        @input="input"
      ></v-color-picker>
    </v-menu>
    <div v-if="$slots['append']" class="pa-2 flex-grow-1">
      <slot name="append" />
    </div>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  props: {
    label: { type: String, default: ' Màu hiển thị' },
    value: { type: String },
    hideLabel: Boolean,
    readonly: Boolean,
    mode: {
      type: String,
      default: 'hexa',
    },
  },
  data: () => ({ color: '#000', menu: false }),
  watch: {
    value: {
      handler(value) {
        this.color = value ? value : '#000'
      },
      immediate: true,
    },
  },
  methods: {
    input(e) {
      this.$emit('input', e)
    },
  },
}
</script>
